module.exports = __webpack_public_path__ + "static/media/杭电@2x.f85de58d.png";